import { StatusBadge } from "@/components/common/ui-kit";

export const ORDER_STATUS = { ricevuto: ["Ricevuto", "blue"], verificato: ["Verificato", "blue"], confermato: ["Confermato", "green"], in_evasione: ["In evasione", "amber"],
  parzialmente_evaso: ["Parzialmente evaso", "amber"], evaso: ["Evaso", "green"], annullato: ["Annullato", "neutral"] };
export const ORDER_ACTIONS = { verificato: "Segna verificato", confermato: "Conferma ordine", in_evasione: "Avvia evasione" };
export const FULFILL = { da_evadere: ["Da evadere", "neutral"], parziale: ["Parziale", "amber"], evasa: ["Evasa", "green"] };
export const ORDER_LINKS = { asset: "Asset", license: "Licenza", intervention: "Intervento", package: "Pacchetto ore" };
export const ORDER_BILLING = { da_fatturare: ["Da fatturare", "amber"], acconto_fatturato: ["Acconto fatturato", "blue"], fatturato: ["Fatturato", "green"] };

export const OrderBilling = ({ o, testId }) => {
  if (o.status === "annullato") return null;
  const [l, t] = ORDER_BILLING[o.billing_status || "da_fatturare"];
  return <StatusBadge tone={t} data-testid={testId}>{l}</StatusBadge>;
};

export const OrderStatus = ({ value, testId }) => { const [l, t] = ORDER_STATUS[value] || [value, "neutral"]; return <StatusBadge tone={t} data-testid={testId}>{l}</StatusBadge>; };
export const LineFulfill = ({ value, testId }) => { const [l, t] = FULFILL[value] || [value, "neutral"]; return <StatusBadge tone={t} data-testid={testId}>{l}</StatusBadge>; };
